import { useLingui } from '@lingui/react';
import { useEffect, useRef } from 'react';

import { activateLocale, type Locale, SUPPORTED_LOCALES } from '../i18n';

export default function Footer() {
  const { i18n } = useLingui();
  const ref = useRef<HTMLSdxFooterElement>(null);

  const languages = SUPPORTED_LOCALES.map((l) => ({
    label: l.label,
    active: i18n.locale === l.value,
    href: '#',
    dataset: { locale: l.value },
    eventMapping: { click: 'languageSwitch' },
  }));

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    function handleLanguageSwitch(e: Event) {
      e.preventDefault();
      const detail = (e as CustomEvent).detail;
      const locale = detail?.item?.dataset?.locale as Locale | undefined;
      if (locale) {
        activateLocale(locale);
        localStorage.setItem('cms-locale', locale);
      }
    }

    el.addEventListener('languageSwitch', handleLanguageSwitch);
    return () => el.removeEventListener('languageSwitch', handleLanguageSwitch);
  }, []);

  return <sdx-footer ref={ref} languages={languages} />;
}
